import React from 'react';

import { childrenPropTypes } from '../../utils/propTypesUtils';
import { useSSRQuery } from '../useSSRQuery';
import CART_QUERY from '../../components/siteLayout/siteHeader/cart.query.graphql.js';

export const CartData = React.createContext({});
export const useCart = () => React.useContext(CartData);

const CartProvider = ({ children }) => {
  const { loading, error, data, refetch } = useSSRQuery(CART_QUERY, {
    fetchPolicy: 'network-only',
  });

  return (
    <CartData.Provider
      value={{
        cart: data,
        cartError: error,
        cartLoading: loading,
        // cart would be expired if data object would be there but order will be null
        cartExpired: data && !data.order,
        // update cart would be used wherever a mutatuion happens that requires cart update.
        updateCart: refetch,
      }}
    >
      {children}
    </CartData.Provider>
  );
};
CartProvider.propTypes = childrenPropTypes;

export default CartProvider;
